/* eslint-disable camelcase */

/** 네이버 애널리틱스 사이트식별자(네이버공통키). T1·T2 블록이 같은 값을 써야 한다 */
export const NAVER_WCS_ACCOUNT_ID = 's_2652984f26f1';

/**
 * 네이버 전환 스크립트 신버전(wcs.trans) 전환유형.
 * 구버전(wcs.cnv) 숫자 코드와의 매핑: "1" → purchase, "2" → sign_up
 *
 * @see https://naver.github.io/conversion-tracking/pages/01_script_guide_wcstrans/
 */
export const NaverConversionType = {
  purchase: 'purchase',
  signUp: 'sign_up',
} as const;

export type NaverConversionType = (typeof NaverConversionType)[keyof typeof NaverConversionType];

/**
 * 검증 단계에서 사용하는 전환유형.
 * `test_` prefix 는 구버전(cnv) 전환의 영구 필터링을 트리거하지 않는 네이버 공식 권장 방식이다.
 * prefix 없이 실 유형으로 한 번 발화하면 해당 유형의 cnv 전환이 영구 필터링되며 되돌릴 수 없다.
 */
export type NaverTestConversionType = `test_${NaverConversionType}`;

export interface NaverTransItem {
  /** 상품 ID */
  id: string;
  /** 상품명. 따옴표(' ")가 포함되면 스크립트 오류가 발생하므로 제거해서 넘긴다 */
  name: string;
  quantity: number;
  payAmount: number;
  category?: string;
  option?: string;
}

/**
 * `wcs.trans` 에 전달하는 전환 페이로드.
 *
 * 개인정보 가드레일 — 승객명·연락처·이메일·PNR 등 개인 식별 가능 정보는 어떤 필드에도 넣지 않는다.
 * 상품·주문 단위 정보(주문번호, 상품 ID, 상품명, 노선, 수량, 금액)만 허용한다.
 */
export interface NaverTransConversion {
  type: NaverConversionType | NaverTestConversionType;
  /** 결제금액. purchase 는 필수 */
  value?: string;
  /** 주문번호. 선택이며 권장 */
  id?: string;
  /** 선택. 넣을 경우 각 항목의 id·name·quantity·payAmount 가 모두 필수 */
  items?: NaverTransItem[];
  /** 생략 시 KRW */
  currency?: string;
}

export interface NaverAnalytics {
  trans: (conversion: NaverTransConversion) => void;
  inflow: (host: string) => void;
}

export interface NaverAnlyticsAdditionalOption {
  wa: string;
}

/** `wcs_do()` — trans 버전은 인자를 받지 않는다(구버전은 `wcs_do(_nasa)`) */
export type NaverAnalyticsFunction = () => void;
